import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const Pagination = ({ currentPage, lastPage, onPageChange }) => {
  if (lastPage <= 1) return null;

  const pages = Array.from({ length: lastPage }, (_, i) => i + 1);

  return (
    <nav className="d-flex justify-content-center mt-4">
      <ul className="pagination gap-2">

        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
          <button
            className="page-link rounded-circle d-flex align-items-center justify-content-center shadow-sm"
            style={{ width: 38, height: 38 }}
            onClick={() => onPageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            <FaChevronLeft />
          </button>
        </li>

        {pages.map((page) => (
          <li key={page} className="page-item">
            <button
              className={`page-link rounded-circle d-flex align-items-center justify-content-center shadow-sm ${
                page === currentPage
                  ? "bg-primary text-white border-primary"
                  : "bg-white text-dark"
              }`}
              style={{ width: 38, height: 38 }}
              onClick={() => onPageChange(page)}
            >
              {page}
            </button>
          </li>
        ))}

        <li className={`page-item ${currentPage === lastPage ? "disabled" : ""}`}>
          <button
            className="page-link rounded-circle d-flex align-items-center justify-content-center shadow-sm"
            style={{ width: 38, height: 38 }}
            onClick={() => onPageChange(currentPage + 1)}
            disabled={currentPage === lastPage}
          >
            <FaChevronRight />
          </button>
        </li>

      </ul>
    </nav>
  );
};

export default Pagination;
